import { Box, Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from '@chakra-ui/react'
import type { AxiosError } from 'axios'
import type { InsuranceParamsTravelDto } from 'BrokerTsLib/src/dtos'
import * as global from 'brokertslib/src/helpers/global'
import { FormProvider, useForm, yupResolver } from 'BrokerTsLib/src/rhf'
import { useContext } from 'react'
import ErrorSummary from '../components/ErrorSummary'
import { schema } from '../containers/cestovko/Step2Form'
import { useCestovkoOffersContext } from '../context/CestovkoOffersProvider'
import { useSaveStep2 } from '../hooks/useWizard'
import { Save } from '../icons'
import { insuranceParamsContext } from '../layouts/Wizard'
import type { Step2FormValues } from './cestovko/Step2Form'
import { transformInsuranceParamsToStep2FormValues } from './cestovko/Step2Form'
import { ExtraInsuranceCestovko } from './ExtraInsuranceCestovko'

function ExtraInsuranceCestovkoModal({
  isOpen = false,
  onClose
}: {
  isOpen: boolean
  onClose: () => void
}) {
  const { mutateAsync: submitForm, isPending: isSaving } = useSaveStep2()
  const { recalculateOffers: recalculate } = useCestovkoOffersContext()

  const { insuranceParams: insuranceParamsGeneric, insuranceParamsId: paramsId, refetchInsuranceParams } = useContext(insuranceParamsContext)!
  const insuranceParams = insuranceParamsGeneric as InsuranceParamsTravelDto

  const formValues = transformInsuranceParamsToStep2FormValues(insuranceParams, paramsId)

  const methods = useForm<Step2FormValues>({
    defaultValues: formValues,
    resolver: yupResolver(schema) as any,
    mode: 'onBlur'
  })

  const {
    handleSubmit,
    setError,
    reset,
    formState: { errors },
  } = methods

  const closeModal = () => {
    onClose()
  }

  const onSubmitForm = handleSubmit((data) => {
    return submitForm({ ...data, paramsId: paramsId ?? '' })
      .then((response) => {
        refetchInsuranceParams()
          .then(() => {
            recalculate()
            closeModal()
          })

      })
      .catch((err: AxiosError<any>) => {
        if (!(err.response && err.response.status === 400 && err.response.data))
          return

        const data = err.response.data

        // zobrazeni serverove validace
        Object.keys(data).forEach((x: any) => {
          setError(global.toCamelCase(x), { message: data[x].join(' ') })
        })

        alert('Při ukládání došlo k chybě')
      })
      .finally(() => { })
  })

  return (
    <Modal size="6xl" onClose={onClose} isOpen={isOpen}>
      <ModalOverlay />

      <FormProvider {...methods}>
        <form onSubmit={onSubmitForm}>
          <ModalContent>
            <ModalHeader>Nastavení parametrů pro všechny nabídky</ModalHeader>
            <ModalBody>
              <Box sx={{ display: 'grid', gap: 8 }}>
                <ExtraInsuranceCestovko showIcons={true} />
              </Box>
            </ModalBody>
            <ModalFooter flexDirection='column-reverse' alignItems='flex-end'>
              <Button colorScheme="primary" onClick={onSubmitForm} isLoading={isSaving} isDisabled={isSaving}                            >
                <Save />
                Uložit a přepočítat
              </Button>

              <ErrorSummary errors={errors} />
            </ModalFooter>
          </ModalContent>
        </form>
      </FormProvider>
    </Modal>
  )
}

export default ExtraInsuranceCestovkoModal



